import React, { FC } from "react";
import { AddIconNew } from "../Icons";
import { useModal } from "../../context/ModalContext";
import { MODALS } from "../../config/params";
import { useGTM } from "../../hooks/useGTM";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";

const AddPetTextAndModal: FC = () => {
  const { openModal } = useModal();
  const { dispatchEvent } = useGTM();

  const handleGoToAddAPet = () => {
    openModal(MODALS.ADD_A_PET);
    userActivityLogger(MIXPANEL_EVENTS.ADD_PET, { referred_from: "Dashboard" });
    dispatchEvent({
      eventName: "gv_add_a_pet_dashboard",
    });
  };

  return (
    <span onClick={handleGoToAddAPet} className="flex items-center text-xs cursor-pointer">
      <AddIconNew />
      <span>Add Your Pet</span>
    </span>
  );
};

export default AddPetTextAndModal;
